import { render, staticRenderFns } from "./EditManageLinkType.vue?vue&type=template&id=78140856&scoped=true"
import script from "./EditManageLinkType.vue?vue&type=script&lang=js"
export * from "./EditManageLinkType.vue?vue&type=script&lang=js"
import style0 from "./EditManageLinkType.vue?vue&type=style&index=0&id=78140856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78140856",
  null
  
)

export default component.exports